import { Processor } from '.';
import { MeshAssembly } from '../../bridge/MeshAssembly';
import { Node } from '../Node';
import { Point } from '../component';
import { TransformPosition } from '../../interfaces';
import { ComponentInnerState } from './Processor';

export class PointProcessor extends Processor {
	private getDistanceTo(position: TransformPosition, point: MeshAssembly): number {
		return point.getDistanceTo(position);
	}

	public start(component: Point, node: Node): boolean {
		const iState: ComponentInnerState = new Object();
		iState.meshAssembly = this.engine.meshFactory.createEmpty('point');

		node.addChildAssembly(iState.meshAssembly);

		this.setState(component, iState);
		return true;
	}

	public enable(component: Point): boolean {
		const iState = this.getState(component);
		if (!iState.meshAssembly || !iState.meshAssembly.isReady() || component.isDisabled) {
			return false;
		}
		iState.meshAssembly.localPosition = component.state.position;
		component.getDistanceTo = (p): number =>
			this.getDistanceTo(p, iState.meshAssembly as MeshAssembly);
		component.getWorldPosition = (): TransformPosition =>
			(iState.meshAssembly as MeshAssembly).worldPosition;
		return true;
	}

	public disable(component: Point): boolean {
		const iState = this.getState(component);
		if (iState.meshAssembly) {
			iState.meshAssembly.shouldRender = false;
			return true;
		}
		return false;
	}

	public onDestroy(component: Point): boolean {
		const iState = this.getState(component);
		if (iState.meshAssembly) {
			iState.meshAssembly.shouldRender = false;
			iState.meshAssembly.destroy();
			return true;
		}

		return false;
	}

	public updateState(component: Point, node: Node): boolean {
		const iState = this.getState(component);
		if (iState.meshAssembly) {
			node.addChildAssembly(iState.meshAssembly);
			iState.meshAssembly.localPosition = component.state.position;
			return true;
		}

		return false;
	}
}
